import { BulkSelectManager } from "../components/BulkSelectManager";

/**
 * 관리자 페이지에서 [data-bulk-target] 테이블에 자동으로
 * BulkSelectManager 를 부착한다. GlobalApplication.runAdmin() 에서 1회 호출.
 */
export function initBulkSelect(scope: HTMLElement = document.body): void {
    scope.querySelectorAll<HTMLTableElement>("table[data-bulk-target]").forEach((table) => {
        if (table.dataset.bulkSelectReady === "1") return;
        table.dataset.bulkSelectReady = "1";

        // 우선 테이블 자체의 dataset 사용, 비어 있으면 형제 토글 컨테이너에서 가져온다
        let url = (table.dataset.bulkUrl ?? "").trim();
        let resource = (table.dataset.bulkResource ?? "").trim();

        if (!url || !resource) {
            const wrap = table.parentElement?.closest<HTMLElement>(".admin-page, .admin-table-wrap, body");
            const scopeEl = wrap?.querySelector<HTMLElement>("[data-bulk-target-scope]");
            if (scopeEl) {
                if (!url) url = (scopeEl.dataset.bulkUrl ?? "").trim();
                if (!resource) resource = (scopeEl.dataset.bulkResource ?? "").trim();
            }
        }

        if (!url) return;

        new BulkSelectManager(table, { url, resource }).init();
    });
}
